import { notification, Pagination } from "antd";
import { useEffect, useState } from "react";
import React from "react";
import Select2 from "react-select";
const ManageDownloadLimit = (props) => {
  const { allWorkspaces, getVideoGridState, getWorkspaceDetails, updateClientSetting, updateVideoData } = props;
  const [activePage, setActivePage] = useState(1);
  const [allStream, setAllStream] = useState([]);
  const [selectWorkspace, setSelectWorkspace] = useState("");
  const [options, setOptions] = useState([]);
  const [workspaceConfig, setWorkspaceConfig] = useState({});
  const [inputValues, setInputValues] = useState({});
  const [workspaceLimit, setWorkspaceLimit] = useState("");

  const getVideoGridStates = async (selectWorkspace) => {
    const { value } = await getVideoGridState({
      category: [],
      type: "sports_keymoments",
      status: "all",
      userId: localStorage.getItem("__uid"),
      page_no: activePage,
      sortBy: {
        _id: -1,
      },
      aspectRatio: "",
      dateRange: [],
      searchText: "",
      limit: 20,
      tournaments: [],
      channelName: [],
      showType: [],
      getAdminStream: false,
      entityId: selectWorkspace?.value || "",
    });
    if (value.success) {
      setAllStream(value?.stream);
    } else {
      setAllStream([]);
    }
  };
  const getEntityDetails = async (id) => {
    try {
      const { value } = await getWorkspaceDetails({
        entityId: id?.value,
        getConfig: true,
      });

      if (value?.status) {
        const { workspaceConfig } = value;
        setWorkspaceConfig(workspaceConfig);

        const maxDownloadLimit = workspaceConfig?.limitation?.maximumDownloadLimitAllowedForDeduction ?? "";
        setWorkspaceLimit(maxDownloadLimit);
      } else {
        setWorkspaceConfig({});
        setWorkspaceLimit("");
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  useEffect(() => {
    getEntityDetails(selectWorkspace);
  }, []);

  useEffect(() => {
    getVideoGridStates(selectWorkspace);
    getEntityDetails(selectWorkspace);
  }, [selectWorkspace]);

  useEffect(() => {
    const options =
      allWorkspaces?.map((workspace) => ({
        value: workspace?.workspaceId,
        label: workspace?.displayName || workspace?.name,
      })) || [];

    setOptions(options);
  }, [allWorkspaces]);

  const handleChange = (e) => {
    setSelectWorkspace(e);
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };
  const handleLimitChange = (e, streamId) => {
    const newInputValues = { ...inputValues, [streamId]: e.target.value };
    setInputValues(newInputValues);
  };
  useEffect(() => {
    const limits = {};
    allStream.forEach((stream) => {
      limits[stream.streamId] =
        workspaceConfig.limitation?.maxVideoDownloadDuration - stream?.limitation?.usedVideoDownloadDuration;
    });
  }, [allStream, workspaceConfig]);

  const handleLimitSubmit = async (stream) => {
    try {
      const { limitation } = workspaceConfig || {};
      const remainingDownload = parseInt(inputValues[stream?.streamId], 10);
      if (parseInt(remainingDownload) <= 0) {
        notification.error({ message: "Limit cannot be zero or negative" });
        return;
      }
      if (isNaN(remainingDownload) || remainingDownload > limitation?.maximumDownloadLimitAllowedForDeduction) {
        notification["error"]({
          message: "Input value should not be greater than maximum download limit",
        });
        return;
      }

      const maximumRemainingWorkspaceLimit = limitation?.maximumDownloadLimitAllowedForDeduction - remainingDownload;
      const streamLimitation = stream?.limitation;
      const updatedLimit = streamLimitation
        ? streamLimitation.usedVideoDownloadDuration + remainingDownload
        : maximumRemainingWorkspaceLimit;

      if (isNaN(updatedLimit)) {
        notification["error"]({
          message: "Invalid input value",
        });
        return;
      }

      if (updatedLimit <= limitation?.maxVideoDownloadDuration) {
        const payload = {
          entityId: selectWorkspace?.value,
          limitation: {
            ...limitation,
            maximumDownloadLimitAllowedForDeduction: maximumRemainingWorkspaceLimit,
          },
        };

        await updateClientSetting(payload);

        const { value } = await updateVideoData({
          streamId: stream?.streamId,
          limitation: {
            usedVideoDownloadDuration: updatedLimit,
          },
        });

        if (value?.success) {
          notification["success"]({
            message: value?.message,
          });
          getVideoGridStates(selectWorkspace);
          getEntityDetails(selectWorkspace);
          setInputValues({});
          setWorkspaceLimit(limitation?.maximumDownloadLimitAllowedForDeduction || "");
        } else {
          notification["error"]({
            message: value?.message,
          });
        }
      } else {
        notification["error"]({
          message: "Input value exceeding the allotted download limit",
        });
      }
    } catch (error) {
      console.error("Error handling limit submission:", error);
      notification["error"]({
        message: "An error occurred while processing your request.",
      });
    }
  };

  const handleWorkspaceSubmit = async (id) => {
    if (!workspaceLimit) {
      notification.error({ message: "Limit cannot be blank" });
      return;
    }
    if (parseInt(workspaceLimit) <= 0) {
      notification.error({ message: "Limit cannot be zero or negative" });
      return;
    }
    const limitationObject = workspaceConfig?.limitation;
    const payload = {
      entityId: id.value,
      limitation: {
        ...limitationObject,
        maximumDownloadLimitAllowedForDeduction: Number(workspaceLimit),
      },
    };
    try {
      const { value } = await updateClientSetting(payload);

      if (value?.status) {
        notification.success({ message: value.message });
        getEntityDetails(selectWorkspace);
      } else {
        notification.error({ message: value.message });
        getEntityDetails("");
      }
    } catch (error) {
      notification.error({ message: "An error occurred while updating client settings" });
    }
  };

  const handleWorkspaceLimitChange = (e) => {
    setWorkspaceLimit(e.target.value);
  };

  const handleReset = () => {
    setSelectWorkspace("");
    setWorkspaceLimit("");
    getVideoGridStates("");
    setWorkspaceConfig({});
  };
  return (
    <React.Fragment>
      <div className="manage-download">
        <div className="right-block">
          {workspaceConfig?.limitation?.maximumDownloadLimitAllowedForDeduction > 0 && (
            <h7 className="title-sm-t">
              <span className="download-title">Maximum download limit allowed for deduction - </span>
              <span className="download-limit">
                {`${workspaceConfig?.limitation?.maximumDownloadLimitAllowedForDeduction} second(s)`}{" "}
              </span>
            </h7>
          )}
        </div>
      </div>
      <div className="left-block">
        <h4 className="title-sm-t">Manage deduction limit for workspace</h4>
      </div>

      <br />
      <div className="download-form col-md-4">
        <div className="form-container col-lg-12">
          <div className="field-items mb-4">
            <div className="col-md-12">
              <label className="form-label">
                Workspace<span className="required"></span>
              </label>
              <Select2
                styles={{ width: "100%" }}
                bordered={false}
                value={selectWorkspace}
                onChange={(e) => {
                  handleChange(e);
                }}
                name="workspaces"
                options={options}
              />
            </div>
          </div>
          <div className="field-items mb-4">
            <div className="col-md-12">
              <div className="field-container">
                <input
                  type="number"
                  onChange={(e) => handleWorkspaceLimitChange(e)}
                  placeholder="Enter limit"
                  className="limitInput-field"
                  value={workspaceLimit || ""}
                  disabled={!selectWorkspace}
                />
              </div>
            </div>
          </div>
          <div className="col-md-1 d-flex">
            <button
              disabled={!selectWorkspace}
              onClick={() => handleWorkspaceSubmit(selectWorkspace)}
              className="btn btn-primary"
            >
              Update
            </button>
            <button
              disabled={!workspaceLimit && !selectWorkspace}
              onClick={() => handleReset()}
              className="manage-download-reset btn btn-primary"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
      <br />
      <div className="border-block mt-3">
        <div className="table-resposive table-container manage-download-table">
          {allStream?.length ? (
            <table className="table">
              <thead>
                <tr>
                  <th>Stream Name</th>
                  <th>Stream ID</th>
                  <th>Total limit</th>
                  <th>Remaining limit</th>
                  {workspaceConfig?.limitation?.maximumDownloadLimitAllowedForDeduction > 0 && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {allStream?.map((stream) => (
                  <>
                    {workspaceConfig?.limitation &&
                    workspaceConfig?.limitation?.maxVideoDownloadDuration > 0 &&
                    workspaceConfig?.limitation?.maxVideoDownloadDuration -
                      stream?.limitation?.usedVideoDownloadDuration !==
                      0 ? (
                      <tr key={stream?.streamId}>
                        <td>{stream?.title}</td>
                        <td>{stream?.streamId}</td>
                        <td>{workspaceConfig?.limitation?.maxVideoDownloadDuration}</td>
                        <td>
                          {!stream?.limitation?.usedVideoDownloadDuration
                            ? workspaceConfig?.limitation?.maxVideoDownloadDuration
                            : workspaceConfig?.limitation?.maxVideoDownloadDuration -
                              stream?.limitation?.usedVideoDownloadDuration}
                        </td>
                        {workspaceConfig?.limitation?.maximumDownloadLimitAllowedForDeduction > 0 && (
                          <td>
                            <div className="field-items mb-4">
                              <div className="col-md-12">
                                <div className="field-container">
                                  <input
                                    type="number"
                                    value={inputValues[stream?.streamId] || ""}
                                    onChange={(e) => handleLimitChange(e, stream?.streamId)}
                                    placeholder="Enter limit"
                                    className="Input-field"
                                    min={0}
                                    max={
                                      workspaceConfig?.limitation?.maxVideoDownloadDuration &&
                                      workspaceConfig?.limitation?.maxVideoDownloadDuration -
                                        stream?.limitation?.usedVideoDownloadDuration
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="button-container">
                              <button onClick={() => handleLimitSubmit(stream)} className="btn btn-primary">
                                Update
                              </button>
                            </div>
                          </td>
                        )}
                      </tr>
                    ) : null}
                  </>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="text-center pt-5 pb-5">
              <h3>No streams found</h3>
            </div>
          )}
        </div>
      </div>
      <Pagination
        hideOnSinglePage
        current={activePage}
        pageSize={20}
        onChange={handlePageChange}
        //total={templatesCount}
        className="text-center mt-3"
      />
    </React.Fragment>
  );
};

export default ManageDownloadLimit;
